import { memo } from 'react';
import { useIntl } from 'react-intl';
import { PresetButtonColors } from '@tinderapp/ui-react';
import noop from 'lodash/noop';

import { I13N_CATEGORY_LOGIN } from 'Lib/constants/i13nSpec';

import { VARIANT_OVERLAY } from 'Containers/PageLayout/Header/lib/constants';
import TinderLogo from 'Containers/PageLayout/TinderLogoLink';
import useAgeGate from 'Components/AgeGate/hooks/useAgeGate';
import { I13nDiv } from 'Components/I13n';
import LanguagePicker from 'Components/LanguagePicker';
import Button from 'Components/Obsidian/Button';

import useInstrumentation from '../hooks/useInstrumentation';
import useLoginModal from '../hooks/useLoginModal';

const LoginLite = () => {
  const { formatMessage } = useIntl();

  useAgeGate({ handleCloseModal: noop });
  useInstrumentation();

  const { openLoginModal, openCreateAccountModal } = useLoginModal();

  return (
    <I13nDiv
      className="Expand Bgi($primary-gradient-vertical)"
      i13nModel={{ category: I13N_CATEGORY_LOGIN, label: 'LoginLite' }}
    >
      <div className="Expand Pos(r) Ovy(s) Ovs(touch) Sb(s) Ovsby(n)">
        <div className="C($c-ds-text-primary-inverse) Expand Ta(c) Py(12px) Pos(r) Ovy(s)">
          <div className="Expand D(f) Fxd(c) Jc(fe) Ai(c)">
            <LanguagePicker className="Pos(a) End(0) T(0) P(12px)" variant={VARIANT_OVERLAY} />
            <div className="CenterAlign Fx($flx1)">
              <TinderLogo className="M(a) W(50vw)" type="white" />
            </div>
            <div className="D(ib)--s W(100%)--s My(12px)--s My(8px)--xs">
              <Button
                {...PresetButtonColors.PrimaryOverlay}
                size="large"
                className="Mb(20px) W(100%)--ml W(80%)--s"
                onClick={openCreateAccountModal}
                i13nModel={{ message: 'Create Account' }}
                data-testid="lite-create-account"
              >
                {formatMessage({ id: 'createAccount' })}
              </Button>
              <Button
                {...PresetButtonColors.SecondaryOverlay}
                size="large"
                className="W(100%)--ml W(80%)--s Mb(40px)"
                onClick={openLoginModal}
                i13nModel={{ message: 'Login' }}
                data-testid="lite-log-in"
              >
                {formatMessage({ id: 'LoginPage.logIn' })}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </I13nDiv>
  );
};

export default memo(LoginLite);
